import React from 'react';

/**
 * Знак-монограмма «sn» из Лого/sn.svg.
 *
 * Один файл на обе темы — брендбук 4.2:
 *  - «s» → currentColor, наследует --color-text-primary
 *  - «n» → --color-action, то есть #0072EF на светлой и #3194FF на тёмной.
 *    Литерал #007AFF на тёмном фоне даёт 4.66/4.15/2.47 — впритык и ниже
 *
 * Пропорции 1486×604 (≈2.46:1). Минимальная высота — 16px (брендбук 4.3).
 */
const Logo = ({ height = 22, className = '', title = 'spbneformal' }) => (
  <svg
    viewBox="0 0 1486 604"
    height={height}
    width={height * (1486 / 604)}
    role="img"
    aria-label={title}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M693 402C693 446 679.667 483 653 513C626.333 543 588.333 565.667 539 581C489.667 596.333 430.333 604 361 604C289.667 604 227 595.333 173 578C119.667 560.667 78 536.333 48 505C18 473.667 2 437.333 0 396H207C211.667 411.333 220.667 424.667 234 436C248 446.667 266.333 455 289 461C311.667 466.333 338.667 469 370 469C410.667 469 441.333 465 462 457C483.333 449 494 437 494 421C494 408.333 486 399 470 393C454 386.333 426.667 381.333 388 378L287 370C219.667 365.333 166 355.333 126 340C86.6667 324 58.3333 303.667 41 279C23.6667 253.667 15 225 15 193C15 149.667 28.3333 114 55 86C82.3333 57.3333 120 36 168 22C216.667 7.33332 273.333 0 338 0C402 0 459 8.33333 509 25C559 41.6666 599 65 629 95C659 124.333 676.333 159 681 199H474C470.667 186.333 463.333 175 452 165C440.667 154.333 425 145.667 405 139C385 132.333 359.333 129 328 129C291.333 129 263.333 133 244 141C225.333 149 216 160.333 216 175C216 186.333 221.667 195.333 233 202C245 208.667 267 213.333 299 216L432 226C498 230 550 239.667 588 255C626 269.667 653 289.333 669 314C685 338.667 693 368 693 402Z"
    />
    <path
      fill="var(--color-action)"
      d="M774.117 17H979.117L1016.12 245V588H812.117V214L774.117 17ZM1226.12 0C1280.78 0 1327.45 11 1366.12 33C1404.78 55 1434.12 86 1454.12 126C1474.78 166 1485.12 213.333 1485.12 268V588H1281.12V298C1281.12 255.333 1270.12 222.667 1248.12 200C1226.78 177.333 1195.78 166 1155.12 166C1127.12 166 1102.45 172 1081.12 184C1060.45 196 1044.45 213 1033.12 235C1021.78 257 1016.12 283 1016.12 313L953.117 280C961.117 219.333 978.117 168.333 1004.12 127C1030.12 85 1062.12 53.3333 1100.12 31.9999C1138.12 10.6666 1180.12 0 1226.12 0Z"
    />
  </svg>
);

export default Logo;
